import { containsArabic } from './containsArabic';

export type FieldIssue = 'missing' | 'arabic' | null;

/**
 * Detects if a Thiqah- or Lean-provided field has a data quality issue that
 * requires the agent to manually enter a corrected value.
 *
 * - 'missing' → value is null/undefined/empty string (Thiqah returned nothing)
 * - 'arabic'  → value is present but contains Arabic characters (unusable downstream)
 * - null      → value is clean English text; no agent action needed
 *
 * Used to:
 *  1. Conditionally enable/disable "Agent Updates" input fields (only editable when there IS an issue).
 *  2. Drive the red badge and "Missing/Wrong Retrieved Data" tab in the Screening Result step.
 */
export const detectFieldIssue = (value?: string | null): FieldIssue => {
  if (!value) return 'missing';
  if (containsArabic(value)) return 'arabic';
  return null;
};

